import el from "@cypherpotato/el";
import { joinObjects } from "../util";

export function SizableContainer(...children) {
    return el(".sizable-container[redrawable]",
        ...children,
        {
            mount() {
                this.redraw();
            },
            $functions: {
                redraw() {
                    const childrenCount = this.querySelectorAll(".sizable-section").length;
                    this.querySelectorAll(".sizable-section").forEach(section => {
                        section.style.flex = `0 0 ${(1 / childrenCount * 100).toFixed(0)}%`;
                    });
                }
            }
        }
    );
}

export function SizableSection(title, ...children) {
    return el(".sizable-section",
        el(".sizable-section-title", title, {
            onMouseDown(event) {
                event.preventDefault();

                const handle = event.currentTarget;
                const currentSection = handle.parentElement;
                const prevSection = currentSection.previousElementSibling;

                if (!prevSection) {
                    return;
                }

                const startY = event.clientY;
                const startHeightCurrent = currentSection.getBoundingClientRect().height;
                const startHeightPrev = prevSection.getBoundingClientRect().height;

                function onMouseMove(e) {
                    const dy = e.clientY - startY;

                    const newHeightPrev = startHeightPrev + dy;
                    const newHeightCurrent = startHeightCurrent - dy;

                    prevSection.style.flex = `0 0 ${newHeightPrev}px`;
                    currentSection.style.flex = `0 0 ${newHeightCurrent}px`;
                }

                function onMouseUp() {
                    document.removeEventListener("mousemove", onMouseMove);
                    document.removeEventListener("mouseup", onMouseUp);
                }

                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
            }
        }),
        el(".sizable-section-content",
            ...children
        )
    )
}

export function HorizontalSizableContainer(...children) {
    return el(".horizontal-sizable-container[redrawable]",
        ...children,
        {
            mount() {
                const childrenCount = this.querySelectorAll(".horizontal-sizable-section").length;
                this.querySelectorAll(".horizontal-sizable-section").forEach(section => {
                    if (!section.style.flex)
                        section.style.flex = `0 0 ${(1 / childrenCount * 100).toFixed(0)}%`;
                });
            }
        }
    );
}

export function HorizontalSizableSection(...children) {
    const initialSize = joinObjects(...children)?.initialSize;

    return el(".horizontal-sizable-section[redrawable]",
        {
            style: {
                flex: initialSize && `0 0 ${initialSize}`
            },
            // mount() {
            //     this.redraw();
            // },
            // $functions: {
            //     redraw() {
            //         var height = baseHeight(this.closest("[height-target]") ?? this.parentElement);
            //         this.style.height = height + "px";
            //     }
            // }
        },
        el(".horizontal-sizable-section-resize-splitter", {
            onMouseDown(event) {
                event.preventDefault();

                const handle = event.currentTarget;
                const currentSection = handle.parentElement;
                const prevSection = currentSection.previousElementSibling;

                if (!prevSection) {
                    return;
                }

                const startX = event.clientX;

                const startWidthCurrent = currentSection.getBoundingClientRect().width;
                const startWidthPrev = prevSection.getBoundingClientRect().width;

                function onMouseMove(e) {
                    const dx = e.clientX - startX;

                    const newWidthPrev = startWidthPrev + dx;
                    const newWidthCurrent = startWidthCurrent - dx;

                    prevSection.style.flex = `0 0 ${newWidthPrev}px`;
                    currentSection.style.flex = `0 0 ${newWidthCurrent}px`;
                }

                function onMouseUp() {
                    document.removeEventListener("mousemove", onMouseMove);
                    document.removeEventListener("mouseup", onMouseUp);
                }

                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
            }
        }),
        el(".sizable-section-content",
            ...children
        )
    )
}